import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/nutricion";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllNutricionByTax(params.tratamientoId);
}

export function NutricionList(props) {
  const [nutricionList, setNutricion] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllNutricionByTax(props.id).then(setNutricion).catch(console.log);
  }, [props.id]);
  return (
    <>
      {nutricionList?.length ? (
        <ul className='nutricion cpt-list'>
          {nutricionList
            .sort((a, b) => {
              // Convertir las fechas a objetos de fecha para comparar
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Ordenar de manera descendente (más reciente primero)
              return dateB - dateA;
            })
            .map((nutricion) => (
              <li key={nutricion.id}>
                <NavLink to={`${props.id}/seguimiento/nutricion/${nutricion.id}`}>
                  {`Sesión ${nutricion.meta.nutrNumses}`} -{" "}
                  {`${FormatDate(nutricion.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

      ) : (
        <></>
      )}
    </>
  );
}

export function NutricionListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id='content'>
        <h1>Nutrición</h1>
      </div>
      <div id='actions'>
        {(props.userRole.includes('administrador') || props.userRole.includes('nutricion')) && (
          <Link className='button is-link' to={`new`}>
            Nuevo
          </Link>
        )}
      </div>
    </>
  );
}
